import { render, staticRenderFns } from "./applicationDashboard.vue?vue&type=template&id=35d8b4e5&scoped=true&"
import script from "./applicationDashboard.vue?vue&type=script&lang=js&"
export * from "./applicationDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d8b4e5",
  null
  
)

export default component.exports